export const wecomDeliveryPurpose = {
  'customer-collection': '手动发送账单',
  'integration-test': '联调测试'
}

export const wecomDeliveryStatusEnum = {
  pending: { text: '等待发送', status: 'Default' },
  sending: { text: '发送中', status: 'Processing' },
  accepted: { text: '企微已确认', status: 'Success' },
  failed: { text: '发送失败', status: 'Error' },
  unknown: { text: '结果未知', status: 'Warning' }
}

export const wecomMessageTypeOptions = [
  { label: '测试文字', value: 'markdown' },
  { label: '测试 PDF', value: 'pdf' }
]

export const wecomDeliveryStatus: Partial<
  Record<string, { type: 'info' | 'success' | 'warning' | 'error'; title: string; description: string }>
> = {
  pending: { type: 'info', title: '等待发送', description: '任务已登记，等待企微网关领取。' },
  sending: { type: 'info', title: '正在发送', description: '正在通过现有企微连接推送，请稍候。' },
  accepted: {
    type: 'success',
    title: '企微已确认发送',
    description: '请在目标群核对消息；测试 PDF 还需确认可以打开。平台确认不代表群成员已读。'
  },
  unknown: {
    type: 'warning',
    title: '发送结果未知',
    description: '请先核对目标群消息，再决定是否重新发送，避免重复通知。'
  },
  failed: { type: 'error', title: '未发送', description: '请核对机器人配置、网关和发起人权限后重新测试。' }
}
